export type CellStatus =
  | "P"
  | "L"
  | "A"
  | "O"
  | "S"
  | "TP"
  | "MS"
  | "FS"
  | "H"
  | "pending";

export type VerifyMode = "face" | "fingerprint" | "unknown";

export interface AttendanceCell {
  status: CellStatus;
  late_minutes?: number | null;
  previous_status?: "A" | "L" | string | null;
  first_punch_at?: string | null;
  verify_mode?: VerifyMode | null;
  has_notice?: boolean;
  notice_reason?: string | null;
  is_overridden?: boolean;
  override_reason?: string | null;
  overridden_by?: string | null;
  holiday_name?: string | null;
}

export const CELL_STATUS_LABELS: Record<CellStatus, string> = {
  P: "Present",
  L: "Late",
  A: "Absent",
  O: "Official leave",
  S: "Sick",
  TP: "Taken permission",
  MS: "Mahamantras submitted",
  FS: "Fine submitted",
  H: "Holiday",
  pending: "Pending",
};
